export default "__VITE_ASSET__DXb$Nw5Q__"